import { colors } from '@lmc/common/constants'
import type React from 'react'
import styled from 'styled-components'

type IconSquircleProps = {
  color?: string
  disabled?: boolean
  icon?: string
  isCarePlans?: boolean
  isListView?: boolean
  label?: string
  labelStyles?: React.CSSProperties
  onSelect?: () => void
  size?: number
  style?: React.CSSProperties
  subLabel?: string
}

const IconSquircle = (props: IconSquircleProps) => {
  const {
    icon,
    isListView,
    disabled = false,
    color,
    style,
    label,
    subLabel,
    onSelect,
    size,
    isCarePlans,
    labelStyles
  } = props

  const btnSize = size || 60
  const containerStyle: React.CSSProperties = isListView
    ? {
        ...style,
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
        textAlign: 'left'
      }
    : {
        ...style,
        textAlign: 'center'
      }

  const renderLabel = () => {
    const _label = isCarePlans
      ? label
      : ((label ?? '').split('/')[1] || (label ?? '')).replace(/^\s/, '')

    if (isListView) {
      return (
        <ListLabelContainer>
          <LabelText style={labelStyles}>{_label}</LabelText>
          <br />
          <SubLabelText>{subLabel}</SubLabelText>
        </ListLabelContainer>
      )
    }
    return (
      <p style={{ fontWeight: isCarePlans ? 'bold' : undefined }}>{_label}</p>
    )
  }

  return (
    <Container
      $selectable={!disabled}
      style={containerStyle}
      onClick={onSelect}
    >
      <IconButton
        id="lmc-selectable-icon"
        style={{
          backgroundColor: color || colors.background,
          width: btnSize,
          height: btnSize,
          margin: isListView ? 0 : '0 auto',
          flexShrink: 0
        }}
      >
        <img
          alt=""
          src={icon}
          style={{
            marginTop: btnSize / 4 - 4,
            height: btnSize / 2 || 30
          }}
        />
      </IconButton>
      {(label || subLabel) && renderLabel()}
    </Container>
  )
}

export default IconSquircle

const Container = styled.div<{ $selectable?: boolean }>`
  display: inline-block;
  vertical-align: top;
  ${({ $selectable }) =>
    $selectable &&
    `
    cursor: pointer;
    &:hover #lmc-selectable-icon {
      border: 3px solid rgba(255, 255, 255, 0.5);
    }
  `}
`

const IconButton = styled.div`
  border-radius: 10px;
  border: 3px solid rgba(255, 255, 255, 0);
  height: 60px;
  margin: 0 auto;
  text-align: center;
  transition: border 0.2s ease-in-out;
  width: 60px;
`

const LabelText = styled.span`
  font-size: 18px;
`

const ListLabelContainer = styled.p`
  line-height: 16px;
  margin-bottom: 0;
  margin-left: 10px;
  margin-top: 4px;
`

const SubLabelText = styled.span`
  font-size: 12px;
  opacity: 0.8;
`
